module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "main-content--body"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "main-content--panel"
  }, [_c('div', {
    staticClass: "panel--top"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel--bottom"
  }, [_c('h3', {
    staticClass: "text-left text-md m-t-md"
  }, [_vm._v("Tag Teammates")]), _vm._v(" "), _c('p', {
    staticClass: "text-left text-sm m-t-sm"
  }, [_vm._v("Type in the usernames (comma separated) of team members you want to be notified whenever you sign in and sign out.")]), _vm._v(" "), _c('form', {
    staticClass: "m-t-md"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label m-t-xs"
  }, [_vm._v("Teammates")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tagged),
      expression: "tagged"
    }],
    staticClass: "input form-control",
    attrs: {
      "placeholder": "Slack usernames: e.g. Jane, Joe, Jim",
      "type": "text"
    },
    domProps: {
      "value": (_vm.tagged)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tagged = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('h3', {
    staticClass: "text-left text-md m-t-md"
  }, [_vm._v("Change Timezone")]), _vm._v(" "), _c('p', {
    staticClass: "text-left text-sm m-t-sm"
  }, [_vm._v("Select your timezone so all dates and time on Worklogs are in your timezone.")]), _vm._v(" "), _c('form', {
    staticClass: "m-t-md"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label m-t-xs"
  }, [_vm._v("Timezone")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timezone),
      expression: "timezone"
    }],
    staticClass: "input form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timezone = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Pacific/Midway"
    }
  }, [_vm._v("(UTC-11:00) Midway Island")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Samoa"
    }
  }, [_vm._v("(UTC-11:00) Samoa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Honolulu"
    }
  }, [_vm._v("(UTC-10:00) Hawaii")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "US/Alaska"
    }
  }, [_vm._v("(UTC-09:00) Alaska")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Los_Angeles"
    }
  }, [_vm._v("(UTC-08:00) Pacific Time (US & Canada)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Tijuana"
    }
  }, [_vm._v("(UTC-08:00) Tijuana")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "US/Arizona"
    }
  }, [_vm._v("(UTC-07:00) Arizona")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Chihuahua"
    }
  }, [_vm._v("(UTC-07:00) Chihuahua")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Chihuahua"
    }
  }, [_vm._v("(UTC-07:00) La Paz")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Mazatlan"
    }
  }, [_vm._v("(UTC-07:00) Mazatlan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "US/Mountain"
    }
  }, [_vm._v("(UTC-07:00) Mountain Time (US & Canada)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Managua"
    }
  }, [_vm._v("(UTC-06:00) Central America")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "US/Central"
    }
  }, [_vm._v("(UTC-06:00) Central Time (US & Canada)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Mexico_City"
    }
  }, [_vm._v("(UTC-06:00) Guadalajara")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Mexico_City"
    }
  }, [_vm._v("(UTC-06:00) Mexico City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Monterrey"
    }
  }, [_vm._v("(UTC-06:00) Monterrey")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Canada/Saskatchewan"
    }
  }, [_vm._v("(UTC-06:00) Saskatchewan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Bogota"
    }
  }, [_vm._v("(UTC-05:00) Bogota")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "US/Eastern"
    }
  }, [_vm._v("(UTC-05:00) Eastern Time (US & Canada)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "US/East-Indiana"
    }
  }, [_vm._v("(UTC-05:00) Indiana (East)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Lima"
    }
  }, [_vm._v("(UTC-05:00) Lima")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Bogota"
    }
  }, [_vm._v("(UTC-05:00) Quito")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Canada/Atlantic"
    }
  }, [_vm._v("(UTC-04:00) Atlantic Time (Canada)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Caracas"
    }
  }, [_vm._v("(UTC-04:30) Caracas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/La_Paz"
    }
  }, [_vm._v("(UTC-04:00) La Paz")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Santiago"
    }
  }, [_vm._v("(UTC-04:00) Santiago")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Canada/Newfoundland"
    }
  }, [_vm._v("(UTC-03:30) Newfoundland")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Sao_Paulo"
    }
  }, [_vm._v("(UTC-03:00) Brasilia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Argentina/Buenos_Aires"
    }
  }, [_vm._v("(UTC-03:00) Buenos Aires")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Argentina/Buenos_Aires"
    }
  }, [_vm._v("(UTC-03:00) Georgetown")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Godthab"
    }
  }, [_vm._v("(UTC-03:00) Greenland")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Noronha"
    }
  }, [_vm._v("(UTC-02:00) Mid-Atlantic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Atlantic/Azores"
    }
  }, [_vm._v("(UTC-01:00) Azores")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Atlantic/Cape_Verde"
    }
  }, [_vm._v("(UTC-01:00) Cape Verde Is.")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Africa/Casablanca"
    }
  }, [_vm._v("(UTC+00:00) Casablanca")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/London"
    }
  }, [_vm._v("(UTC+00:00) Edinburgh")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Etc/Greenwich"
    }
  }, [_vm._v("(UTC+00:00) Greenwich Mean Time : Dublin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Lisbon"
    }
  }, [_vm._v("(UTC+00:00) Lisbon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/London"
    }
  }, [_vm._v("(UTC+00:00) London")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Africa/Monrovia"
    }
  }, [_vm._v("(UTC+00:00) Monrovia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UTC"
    }
  }, [_vm._v("(UTC+00:00) UTC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Amsterdam"
    }
  }, [_vm._v("(UTC+01:00) Amsterdam")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Belgrade"
    }
  }, [_vm._v("(UTC+01:00) Belgrade")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Berlin"
    }
  }, [_vm._v("(UTC+01:00) Berlin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Berlin"
    }
  }, [_vm._v("(UTC+01:00) Bern")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Bratislava"
    }
  }, [_vm._v("(UTC+01:00) Bratislava")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Brussels"
    }
  }, [_vm._v("(UTC+01:00) Brussels")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Budapest"
    }
  }, [_vm._v("(UTC+01:00) Budapest")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Copenhagen"
    }
  }, [_vm._v("(UTC+01:00) Copenhagen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Ljubljana"
    }
  }, [_vm._v("(UTC+01:00) Ljubljana")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Madrid"
    }
  }, [_vm._v("(UTC+01:00) Madrid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Paris"
    }
  }, [_vm._v("(UTC+01:00) Paris")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Prague"
    }
  }, [_vm._v("(UTC+01:00) Prague")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Rome"
    }
  }, [_vm._v("(UTC+01:00) Rome")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Sarajevo"
    }
  }, [_vm._v("(UTC+01:00) Sarajevo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Skopje"
    }
  }, [_vm._v("(UTC+01:00) Skopje")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Stockholm"
    }
  }, [_vm._v("(UTC+01:00) Stockholm")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Vienna"
    }
  }, [_vm._v("(UTC+01:00) Vienna")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Warsaw"
    }
  }, [_vm._v("(UTC+01:00) Warsaw")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Africa/Lagos"
    }
  }, [_vm._v("(UTC+01:00) West Central Africa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Zagreb"
    }
  }, [_vm._v("(UTC+01:00) Zagreb")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Athens"
    }
  }, [_vm._v("(UTC+02:00) Athens")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Bucharest"
    }
  }, [_vm._v("(UTC+02:00) Bucharest")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Africa/Cairo"
    }
  }, [_vm._v("(UTC+02:00) Cairo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Africa/Harare"
    }
  }, [_vm._v("(UTC+02:00) Harare")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Helsinki"
    }
  }, [_vm._v("(UTC+02:00) Helsinki")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Istanbul"
    }
  }, [_vm._v("(UTC+02:00) Istanbul")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Jerusalem"
    }
  }, [_vm._v("(UTC+02:00) Jerusalem")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Helsinki"
    }
  }, [_vm._v("(UTC+02:00) Kyiv")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Africa/Johannesburg"
    }
  }, [_vm._v("(UTC+02:00) Pretoria")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Riga"
    }
  }, [_vm._v("(UTC+02:00) Riga")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Sofia"
    }
  }, [_vm._v("(UTC+02:00) Sofia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Tallinn"
    }
  }, [_vm._v("(UTC+02:00) Tallinn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Vilnius"
    }
  }, [_vm._v("(UTC+02:00) Vilnius")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Baghdad"
    }
  }, [_vm._v("(UTC+03:00) Baghdad")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Kuwait"
    }
  }, [_vm._v("(UTC+03:00) Kuwait")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Minsk"
    }
  }, [_vm._v("(UTC+03:00) Minsk")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Africa/Nairobi"
    }
  }, [_vm._v("(UTC+03:00) Nairobi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Riyadh"
    }
  }, [_vm._v("(UTC+03:00) Riyadh")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Volgograd"
    }
  }, [_vm._v("(UTC+03:00) Volgograd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Tehran"
    }
  }, [_vm._v("(UTC+03:30) Tehran")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Muscat"
    }
  }, [_vm._v("(UTC+04:00) Abu Dhabi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Baku"
    }
  }, [_vm._v("(UTC+04:00) Baku")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Moscow"
    }
  }, [_vm._v("(UTC+04:00) Moscow")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Muscat"
    }
  }, [_vm._v("(UTC+04:00) Muscat")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Moscow"
    }
  }, [_vm._v("(UTC+04:00) St. Petersburg")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Tbilisi"
    }
  }, [_vm._v("(UTC+04:00) Tbilisi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Yerevan"
    }
  }, [_vm._v("(UTC+04:00) Yerevan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Kabul"
    }
  }, [_vm._v("(UTC+04:30) Kabul")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Karachi"
    }
  }, [_vm._v("(UTC+05:00) Islamabad")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Karachi"
    }
  }, [_vm._v("(UTC+05:00) Karachi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Tashkent"
    }
  }, [_vm._v("(UTC+05:00) Tashkent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Calcutta"
    }
  }, [_vm._v("(UTC+05:30) Chennai")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Kolkata"
    }
  }, [_vm._v("(UTC+05:30) Kolkata")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Calcutta"
    }
  }, [_vm._v("(UTC+05:30) Mumbai")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Calcutta"
    }
  }, [_vm._v("(UTC+05:30) New Delhi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Calcutta"
    }
  }, [_vm._v("(UTC+05:30) Sri Jayawardenepura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Katmandu"
    }
  }, [_vm._v("(UTC+05:45) Kathmandu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Almaty"
    }
  }, [_vm._v("(UTC+06:00) Almaty")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Dhaka"
    }
  }, [_vm._v("(UTC+06:00) Astana")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Dhaka"
    }
  }, [_vm._v("(UTC+06:00) Dhaka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Yekaterinburg"
    }
  }, [_vm._v("(UTC+06:00) Ekaterinburg")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Rangoon"
    }
  }, [_vm._v("(UTC+06:30) Rangoon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Bangkok"
    }
  }, [_vm._v("(UTC+07:00) Bangkok")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Bangkok"
    }
  }, [_vm._v("(UTC+07:00) Hanoi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Jakarta"
    }
  }, [_vm._v("(UTC+07:00) Jakarta")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Novosibirsk"
    }
  }, [_vm._v("(UTC+07:00) Novosibirsk")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Hong_Kong"
    }
  }, [_vm._v("(UTC+08:00) Beijing")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Chongqing"
    }
  }, [_vm._v("(UTC+08:00) Chongqing")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Hong_Kong"
    }
  }, [_vm._v("(UTC+08:00) Hong Kong")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Krasnoyarsk"
    }
  }, [_vm._v("(UTC+08:00) Krasnoyarsk")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Kuala_Lumpur"
    }
  }, [_vm._v("(UTC+08:00) Kuala Lumpur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Australia/Perth"
    }
  }, [_vm._v("(UTC+08:00) Perth")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Singapore"
    }
  }, [_vm._v("(UTC+08:00) Singapore")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Taipei"
    }
  }, [_vm._v("(UTC+08:00) Taipei")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Ulan_Bator"
    }
  }, [_vm._v("(UTC+08:00) Ulaan Bataar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Urumqi"
    }
  }, [_vm._v("(UTC+08:00) Urumqi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Irkutsk"
    }
  }, [_vm._v("(UTC+09:00) Irkutsk")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Tokyo"
    }
  }, [_vm._v("(UTC+09:00) Osaka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Tokyo"
    }
  }, [_vm._v("(UTC+09:00) Sapporo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Seoul"
    }
  }, [_vm._v("(UTC+09:00) Seoul")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Tokyo"
    }
  }, [_vm._v("(UTC+09:00) Tokyo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Australia/Adelaide"
    }
  }, [_vm._v("(UTC+09:30) Adelaide")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Australia/Darwin"
    }
  }, [_vm._v("(UTC+09:30) Darwin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Australia/Brisbane"
    }
  }, [_vm._v("(UTC+10:00) Brisbane")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Australia/Canberra"
    }
  }, [_vm._v("(UTC+10:00) Canberra")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Guam"
    }
  }, [_vm._v("(UTC+10:00) Guam")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Australia/Hobart"
    }
  }, [_vm._v("(UTC+10:00) Hobart")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Australia/Melbourne"
    }
  }, [_vm._v("(UTC+10:00) Melbourne")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Port_Moresby"
    }
  }, [_vm._v("(UTC+10:00) Port Moresby")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Australia/Sydney"
    }
  }, [_vm._v("(UTC+10:00) Sydney")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Yakutsk"
    }
  }, [_vm._v("(UTC+10:00) Yakutsk")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Vladivostok"
    }
  }, [_vm._v("(UTC+11:00) Vladivostok")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Auckland"
    }
  }, [_vm._v("(UTC+12:00) Auckland")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Fiji"
    }
  }, [_vm._v("(UTC+12:00) Fiji")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Kwajalein"
    }
  }, [_vm._v("(UTC+12:00) International Date Line West")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Kamchatka"
    }
  }, [_vm._v("(UTC+12:00) Kamchatka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Magadan"
    }
  }, [_vm._v("(UTC+12:00) Magadan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Fiji"
    }
  }, [_vm._v("(UTC+12:00) Marshall Is.")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Magadan"
    }
  }, [_vm._v("(UTC+12:00) New Caledonia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Magadan"
    }
  }, [_vm._v("(UTC+12:00) Solomon Is.")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Auckland"
    }
  }, [_vm._v("(UTC+12:00) Wellington")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Tongatapu"
    }
  }, [_vm._v("(UTC+13:00) Nuku'alofa")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "control submit m-t-md"
  }, [_c('button', {
    staticClass: "button is-primary save-btn",
    class: {
      'is-disabled': _vm.disabled
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("Update\n                "), _c('span', {
    class: {
      'slack-loader': _vm.loading
    }
  })])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-content--header"
  }, [_c('h4', [_vm._v("Settings")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b8ad760"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = 387
// module chunks = 1